var _defs, _polygon, _polygon2, _rect, _rect2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _circle, _circle2, _circle3, _circle4, _g, _circle5, _polygon10, _circle6, _circle7, _polygon11, _circle8, _polygon12, _circle9, _circle10, _circle11, _g2, _circle12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEvisenseLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f4aa66;}.cls-2{fill:#f08e33;}.cls-3{fill:#ec7200;}.cls-4{fill:#32a29b;}.cls-5{fill:#8f5aff;}.cls-6{fill:#1a1628;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "262.97 597.18 260.68 596.53 337.87 323.23 215.98 392.29 173.16 500.42 170.94 499.54 214.07 390.63 214.43 390.42 341.75 318.29 340.96 321.09 262.97 597.18"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "650.76 680.31 649.71 678.16 807.61 600.8 826.37 499.76 828.72 500.2 809.73 602.41 809.2 602.68 650.76 680.31"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 716.62,
    y: 547.22,
    width: 132.08,
    height: 2.39,
    transform: "translate(-151.45 750.3) rotate(-47.21)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 423.39,
    y: 627.14,
    width: 2.39,
    height: 160.71,
    transform: "translate(-387.05 856.07) rotate(-69.4)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "826.54 500.62 765.41 403.78 767.42 402.51 828.55 499.34 826.54 500.62"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "261.39 598.14 260.95 597.67 171.17 500.79 172.93 499.17 262.27 595.57 827.35 498.8 827.75 501.15 261.39 598.14"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "765.68 404.09 659.21 321.83 499.41 265.36 500.2 263.11 660.52 319.82 767.15 402.2 765.68 404.09"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "172.75 500.95 171.36 499.01 492.32 268.14 340.21 321.89 339.42 319.64 507.28 260.33 172.75 500.95"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "650.24 680.43 348.89 680.43 348.55 680.1 261.01 597.72 262.64 595.99 349.84 678.04 650.24 678.04 650.24 680.43"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "650.59 681.47 649.33 680.02 339.78 322.55 172.92 500.8 171.18 499.16 339.85 318.98 340.72 319.98 649.88 677 765.32 402.68 767.52 403.61 650.59 681.47"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "262.51 597.84 261.15 595.88 660.48 318.83 660.93 320.44 738.92 596.53 736.62 597.18 659.09 322.7 262.51 597.84"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 659.79,
    cy: 320.76,
    r: 22.05
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 339.81,
    cy: 320.76,
    r: 22.05
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 827.55,
    cy: 499.98,
    r: 22.05
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 172.05,
    cy: 499.98,
    r: 22.05
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 650.24,
    cy: 679.24,
    r: 22.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 349.36,
    cy: 679.24,
    r: 22.05
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 499.8,
    cy: 264.24,
    r: 22.05
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "500.22 736.89 499.38 734.65 649.59 678.2 736.95 595.99 738.59 597.72 650.66 680.35 500.22 736.89"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 499.8,
    cy: 735.76,
    r: 22.05
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 737.77,
    cy: 596.86,
    r: 11.69
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "807.75 601.85 765.25 403.4 767.58 402.89 810.08 601.35 807.75 601.85"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 766.42,
    cy: 403.14,
    r: 11.69
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "260.66 600.4 215.98 391.71 218.31 391.21 262.99 599.9 260.66 600.4"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 215.02,
    cy: 391.46,
    r: 14.32
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 261.83,
    cy: 596.86,
    r: 11.69
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 808.67,
    cy: 601.6,
    r: 11.69
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m633.2,633.4c36.88-36.88,55.32-85.08,55.26-133.4h-188.65s0,0,0,0l-133.4,133.4c36.88,36.88,85.14,55.26,133.4,55.26h0c52.17,0,99.25-21.11,133.4-55.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m366.56,366.44c36.88-36.88,85.08-55.32,133.4-55.26v188.65s0,0,0,0l-133.4,133.4c-36.88-36.88-55.26-85.14-55.26-133.4h0c0-52.17,21.11-99.25,55.26-133.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m633.2,366.6c-36.82-36.82-85.08-55.2-133.4-55.26v188.65s188.65,0,188.65,0c.06-52.11-21.11-99.25-55.26-133.4Z"
  }))), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 499.77,
    cy: 500,
    r: 60.8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvisenseLogo);
export default __webpack_public_path__ + "static/media/EvisenseLogo.f686268e5cc3b5245b3c198e1d7bc841.svg";
export { ForwardRef as ReactComponent };